<div app-generated-reports class="mileage-group" fxLayout="column">
  <div class="header-group" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row">
      <div>
        <span class="title-header">Reports</span>
        <sup
          ><i
            *ngIf="!isNewWindow"
            class="fa fa-window-restore open-window"
            (click)="openWindow()"></i
        ></sup>
      </div>
    </div>
  </div>
  <div class="mileage-container">
    <div class="sub-header">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false">
        <a
          mat-tab-link
          *ngFor="let link of navLinks"
          [routerLink]="link.path"
          routerLinkActive
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: false }"
          [active]="rla.isActive">
          {{ link.label }}
        </a>
      </nav>
    </div>
    <mat-tab-nav-panel #tabPanel class="body mat-elevation-z2">
      <ng-container *ngIf="isHasAccess; else noAccess">
        <router-outlet></router-outlet>
      </ng-container>
      <ng-template #noAccess>
        <div
          class="height-50vh width100"
          fxLayout="column"
          fxLayoutAlign="center center">
          <h3>{{ rightsError }}</h3>
        </div>
      </ng-template>
    </mat-tab-nav-panel>
  </div>
</div>
